
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components";
import MenuComponent from "@/components/menu/MenuComponent.vue";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfigChomtana from "@/core/config/MainMenuConfig";
import MainMenuConfigAgent from "@/core/config/MainMenuConfigAgent";
import { Decode } from "@/services";

export default defineComponent({
  name: "kt-menu",
  components: {
    MenuComponent,
  },
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    return {
      hasActiveChildren,
      MainMenuConfigChomtana,
      MainMenuConfigAgent,
      asideMenuIcons,
      version,
      translate,
    };
  },
  data: () => ({
    hoverByClickDb: "",
    hoverByClickOther: "",
    index1: "",
    index2: "",
    textColorDb: "",
    textColorOther: "",
    menuData: MainMenuConfigChomtana,
    companyId: "",
  }),
  created() {
    const k: number = Number(localStorage.getItem("indexK"));
    const j: number = Number(localStorage.getItem("indexJ"));
    this.hoverListOther(k, j);
    this.checkMenu();
  },
  methods: {
    checkMenu(): void {
      // let companyId: number | string = localStorage.getItem("companyId") ?? "";
      let companyId = localStorage.getItem("companyId");
      console.log("companyId", companyId);
      if (companyId == "1") {
        this.menuData = MainMenuConfigChomtana;
      } else {
        this.menuData = MainMenuConfigAgent;
      }
    },
    subItemChange() {
      this.hoverByClickOther = "";
      this.textColorOther = "";
    },
    hoverListDb() {
      this.hoverByClickDb = "background-color: AliceBlue;";
      this.textColorDb = "color: #3699ff";
    },
    hoverListOther(k, j) {
      localStorage.setItem("indexK", k);
      localStorage.setItem("indexJ", j);
      this.index1 = j;
      this.index2 = k;
      this.hoverByClickDb = "";
      this.hoverByClickOther = "background-color: AliceBlue;";

      this.textColorDb = "";
      this.textColorOther = "color: #3699ff";
    },
  },
});
